"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _InAppEmployees = _interopRequireDefault(require("./InAppEmployees/InAppEmployees"));
var _InAppVorstand = _interopRequireDefault(require("./InAppVorstand/InAppVorstand"));
var _InAppSIASections = _interopRequireDefault(require("./InAppSIASections/InAppSIASections"));
var _InAppSIASection = _interopRequireDefault(require("./InAppSIASection/InAppSIASection"));
var _InAppSIAProfessionalGroups = _interopRequireDefault(require("./InAppSIAProfessionalGroups/InAppSIAProfessionalGroups"));
var _InAppSpecialists = _interopRequireDefault(require("./InAppSpecialists/InAppSpecialists"));
var _InAppDelegates = _interopRequireDefault(require("./InAppDelegates/InAppDelegates"));
var _InAppCommission = _interopRequireDefault(require("./InAppCommission/InAppCommission"));
var _InAppFachvereine = _interopRequireDefault(require("./InAppFachvereine/InAppFachvereine"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const InApp = _ref => {
  let {
    item,
    history,
    lang,
    translate
  } = _ref;
  const name = item?.inapp?.name;
  if (!name) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (name === 'GS' || name === 'InAppEmployees') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inapp-container"
    }, /*#__PURE__*/_react.default.createElement(_InAppEmployees.default, {
      lang: lang,
      history: history,
      data: item.inapp?.data
    }));
  }
  if (name === 'SIA-Vorstand' || name === 'InAppVorstand') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inapp-container"
    }, /*#__PURE__*/_react.default.createElement(_InAppVorstand.default, {
      data: item.inapp?.data
    }));
  }
  if (name === 'SK' || name === 'InAppSIASections') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inapp-container"
    }, /*#__PURE__*/_react.default.createElement(_InAppSIASections.default, {
      translate: translate,
      lang: lang,
      history: history,
      data: item.inapp?.data
    }));
  }
  if (name === 'InAppSIASection') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inapp-container"
    }, /*#__PURE__*/_react.default.createElement(_InAppSIASection.default, {
      translate: translate,
      lang: lang,
      history: history,
      data: item.inapp?.data
    }));
  }
  if (['InAppSIAProfessionalGroups', 'BGI', 'BGA', 'BGT', 'BGU'].includes(name)) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inapp-container"
    }, /*#__PURE__*/_react.default.createElement(_InAppSIAProfessionalGroups.default, {
      lang: lang,
      variant: name,
      translate: translate,
      history: history,
      data: item.inapp?.data
    }));
  }
  if (['InAppSpecialists', 'FRD', 'FRE', 'FRV'].includes(name)) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inapp-container"
    }, /*#__PURE__*/_react.default.createElement(_InAppSpecialists.default, {
      lang: lang,
      data: item.inapp?.data,
      variant: name,
      translate: translate,
      history: history
    }));
  }
  if (name === 'InAppDelegates') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inapp-container"
    }, /*#__PURE__*/_react.default.createElement(_InAppDelegates.default, {
      lang: lang,
      data: item.inapp?.data,
      translate: translate
    }));
  }
  if (name === 'inAppCommission') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inapp-container"
    }, /*#__PURE__*/_react.default.createElement(_InAppCommission.default, {
      lang: lang,
      data: item.inapp?.data,
      translate: translate,
      frontend_parameter: item.frontend_parameter
    }));
  }
  if (name === 'InAppFachvereine') {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "inapp-container"
    }, /*#__PURE__*/_react.default.createElement(_InAppFachvereine.default, {
      lang: lang,
      data: item.inapp?.data,
      translate: translate
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-padding-02-left sia-padding-02-bottom"
  }, "TO DO:", item.paragraph_type, " ", name));
};
var _default = exports.default = InApp;